<template>
  <agent-status-item-sidebar
    :actions-type="actionsType"
    :statuses="statusesById"
    :target-key="targetKey"
    :is-updating-type="isUpdatingType"
    @item-change="onTargetItemChange"
    @create="onAddAgentStatus"
    @update="onUpdateAgentStatus"
    @cancel="onCancelTargetItem"
    @delete="onDeleteAgentStatus"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import AgentStatusItemSidebar from '../components/AgentStatusItemSidebar.vue';
import { useAgentStatusSettings } from '../composables';

export default defineComponent({
  name: 'AgentStatusItemSidebarContainer',
  components: { AgentStatusItemSidebar },
  setup() {
    const {
      actionsType,
      statusesById,
      targetKey,
      isUpdatingType,
      onTargetItemChange,
      onAddAgentStatus,
      onUpdateAgentStatus,
      onCancelTargetItem,
      onDeleteAgentStatus,
    } = useAgentStatusSettings();

    return {
      actionsType,
      statusesById,
      targetKey,
      isUpdatingType,
      onTargetItemChange,
      onAddAgentStatus,
      onUpdateAgentStatus,
      onCancelTargetItem,
      onDeleteAgentStatus,
    };
  },
});
</script>
